export const EXAM_BROWSER_HEADER = 'X-Exam-Browser-Key';
export const EXAM_SESSION_REPLACED_EVENT = 'exam-session-replaced';
const STORAGE_KEY = 'cbt-exam-browser-key';

/** Shared across tabs and reloads on this browser; never use the IP as a credential. */
export function getExamBrowserKey(): string {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && /^[a-f0-9]{64}$/.test(stored)) return stored;
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  const key = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
  localStorage.setItem(STORAGE_KEY, key);
  return key;
}
